import { colors } from 'pages/new-questions/styles/common';
import styled from 'styled-components';

export const ResultContainer = styled.div`
  width: 100%;
  padding: 24px;
  background: ${colors.greenBackground};
  border: 2px solid ${colors.green};
  border-radius: 12px;
  animation: fadeIn 0.5s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &.high {
    border-color: ${colors.green};
    background: ${colors.greenBackground};
  }

  &.medium {
    border-color: ${colors.yellow};
    background: ${colors.yellowBackground};
  }

  &.low {
    border-color: ${colors.red};
    background: ${colors.redBackground};
  }
`;

export const ResultHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const ResultTitle = styled.h4`
  font-family: Manrope, sans-serif;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 3%;
  vertical-align: middle;
  color: #000000;
  margin: 0;
`;

export const ResultScore = styled.p`
  font-family: Manrope, sans-serif;
  font-weight: 800;
  font-style: ExtraBold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 26px;
  letter-spacing: 2%;
  margin: 16px 0 0 0;

  &.high {
    color: ${colors.green};
  }

  &.medium {
    color: ${colors.yellow};
  }

  &.low {
    color: ${colors.red};
  }
`;

export const ResultAnswer = styled.p`
  margin: 0;
  font-family: Manrope, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 3%;
  vertical-align: middle;
  color: ${colors.black};
`;

export const ResultFeedback = styled.div`
  margin: auto 0 0 0;
  padding: 16px 0;
  font-family: Manrope, sans-serif;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 3%;
  color: ${colors.black};
`;
